export class DeviceVersion {
    id: string;
    version: string;
}
